import React, { useState } from "react";
import styled from "styled-components";
import i18n from "i18n-iso-countries";
// Import English language definitions for i18n-iso-countries
import english from "i18n-iso-countries/langs/en.json";
import { ElementContainer } from "../containers/styledComponents";
import { CompassParagraph } from "../common/styledComponents";
import { Icon, IconContainer } from "./styledComponents";

// Register the English locale
i18n.registerLocale(english);
const COUNTRY_FLAG_PATH_PREFIX = "/flags/3x2";

const StyledIcon = styled(Icon)`
  border-radius: 8px;
`;

export const CountryWFlag = ({
  countryIso2,
}: CountryWFlagProps): JSX.Element => {
  const [flagLoaded, setFlagLoaded] = useState(false);
  const flagUrl = `${COUNTRY_FLAG_PATH_PREFIX}/${countryIso2.toUpperCase()}.svg`;
  const countryName = i18n.getName(countryIso2.toUpperCase(), "en");

  return (
    <ElementContainer ai="center">
      <IconContainer size={33} br={12} p={2} isLoading={!flagLoaded}>
        <StyledIcon src={flagUrl} onLoad={(): void => setFlagLoaded(true)} />
      </IconContainer>
      <CompassParagraph fontSize={12}>{countryName}</CompassParagraph>
    </ElementContainer>
  );
};

type CountryWFlagProps = {
  countryIso2: string;
};
